import React from "react";
import Service from '../../service/Service';
import * as actions from '../Actions';
// import downarr from '../../assets/images/due_date/due_date_down_arrow.svg';

const service = new Service();
 
export default function FaqsDisclaimer({eleRef}) {
    return (
        <div>
            <div className="duedate-btn-block" id="due_date_faqs">
                <div className="duedate-question faqdiscl-title" id="faq" >
                    <h2 id="faq" className="faqdiscl left B18_21">Frequently Asked Questions</h2>
                    {/* <span className="arrow-down icon downicon" data-icon-font="f" style={{display:"none"}}></span>
                    <span className="arrow-up icon upicon" data-icon-font="n" style={{display:"block"}}></span> */}
                </div>
                <div className="faq-dropdwn" style={{display:"block"}}>
                <div className="duedate-container">
                    <div className="duedate-faq" id="">
                        <div className="duedate-question gtmFaqClick" id="faq1" onClick={() => { actions.duDateQans("faq1") }}>
                            <h2 id="faq1">
                                <span className="M17_42" id="faq1">
                                    <span className="M17_9e gtmFaqClick">Q. </span>
                                    <h3 className="qTitle gtmFaqClick">How many weeks pregnant am I?</h3>
                                </span>
                            </h2>
                            <div className='arr_icon'><img className="gtmFaqClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" /></div>
                            <div className='arr_icon arr_up'><img className="gtmFaqClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" /></div>
                            {/* <span className="arrow-down icon" data-icon-font="f"></span>
                            <span className="arrow-up icon" data-icon-font="n"></span> */}
                        </div>
                        <div className="duedate-answer">
                            <span className="R15_42">
                                A. 
                                To learn how far along you are in your pregnancy or how many weeks pregnant you are, you can use a pregnancy days calculator. Pregnancy usually ranges from 38 to 42 weeks. Calculating the gestational age can be tricky because your baby's age is two weeks less than the pregnancy start date.
                            </span>
                        </div>
                    </div>
                    <div className="duedate-faq" id="">
                        <div className="duedate-question gtmFaqClick" id="faq2" onClick={() => { actions.duDateQans("faq2") }}>
                            <h2 id="faq2">
                                <span className="M17_42" id="faq2">
                                    <span className="M17_9e gtmFaqClick" >Q. </span> 
                                    <h3 className="qTitle gtmFaqClick">Why is the due date calculated from the period?</h3>
                                </span>
                            </h2>
                            <div className='arr_icon'><img className="gtmFaqClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" /></div>
                            <div className='arr_icon arr_up'><img className="gtmFaqClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" /></div>
                        </div>
                        <div className="duedate-answer">
                            <span className="R15_42">
                                A. According to <a href="https://www.nhs.uk/pregnancy/finding-out/due-date-calculator/">NHS</a>, the pregnancy typically lasts from 37 to 42 weeks from the first day of your last period <a href="https://www.nhs.uk/pregnancy/finding-out/due-date-calculator/">(6)</a>. This makes it easier to calculate the due date using the details of the last menstrual cycle.
                            </span>
                        </div>
                    </div>
                    <div className="duedate-faq" id="">
                        <div className="duedate-question gtmFaqClick" id="faq3" onClick={() => { actions.duDateQans("faq3") }}>
                            <h2 id="faq3">
                                <span className="M17_42" id="faq3">
                                    <span className="M17_9e gtmFaqClick" >Q. </span>
                                    <h3 className="qTitle gtmFaqClick">Is the due date based on ovulation?</h3>
                                </span>
                            </h2>
                            <div className='arr_icon'><img className="gtmFaqClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" /></div>
                            <div className='arr_icon arr_up'><img className="gtmFaqClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" /></div>
                        </div>
                        <div className="duedate-answer">
                            <span className="R15_42">
                                A. 
                                No, the due date is not based on ovulation. It is based on the date of conception.
                            </span>
                        </div>
                    </div>
                    <div className="duedate-faq" id="">
                        <div className="duedate-question gtmFaqClick" id="faq4" onClick={() => { actions.duDateQans("faq4") }}>
                            <h2 id="faq4">
                                <span className="M17_42" id="faq4">
                                    <span className="M17_9e gtmFaqClick" >Q. </span>
                                    <h3 className="qTitle gtmFaqClick">How do you calculate pregnancy weeks from the due date?</h3>
                                </span>
                            </h2>
                            <div className='arr_icon'><img className="gtmFaqClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" /></div>
                            <div className='arr_icon arr_up'><img className="gtmFaqClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" /></div>
                        </div>
                        <div className="duedate-answer">
                            <span className="R15_42">
                                A. 
                                Pregnancies typically last about 38 to 40 weeks. To estimate your conception date, note the start of your last menstrual period (LMP) and count 40 weeks (280 days) from that date.
                            </span>
                        </div>
                    </div>
                    <div className="duedate-faq" id="">
                        <div className="duedate-question gtmFaqClick" id="faq5" onClick={() => { actions.duDateQans("faq5") }}>
                            <h2 id="faq5">
                                <span className="M17_42" id="faq5">
                                    <span className="M17_9e gtmFaqClick" >Q. </span>
                                    <h3 className="qTitle gtmFaqClick">Can your due date change?</h3>
                                </span>
                            </h2>
                            <div className='arr_icon'><img className="gtmFaqClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" /></div>
                            <div className='arr_icon arr_up'><img className="gtmFaqClick" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="Due Date Down Arrow" title="Due Date Down Arrow" /></div>
                        </div>
                        <div className="duedate-answer">
                            <span className="R15_42">
                                A. 
                                Yes, the pregnancy due date can change based on your ultrasound scans and last menstrual cycle.
                                It is common for mothers to be sure of their pregnancy and due date calculator is one such tool that simplifies the pregnancy journey. While it is a beneficial tool, it is essential to remember that it is just an estimate, not a guarantee. Be alert, keep yourself informed about different pregnancy nuances, stay in touch with your doctor, and enjoy the pregnancy journey while it lasts.
                            </span>
                        </div>
                    </div>
                    {/* <div className="duedate-faq" id="">
                        <div className="duedate-question" id="faq6" onClick={() => { actions.duDateQans("faq6") }}>
                            <h2 id="faq6">
                                <span className="M17_42" id="faq6">
                                    <span className="M17_9e" id="faq6">Q. </span>
                                    What are the other methods of calculating due dates?
                                </span>
                            </h2>
                            <div className='arr_icon'><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="arrow icon" /></div>
                            <div className='arr_icon arr_up'><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/due_date_down_arrow.svg" alt="arrow icon" /></div>
                        </div>
                        <div className="duedate-answer">
                            <span className="R15_42">
                                A. Several other methods can be employed to calculate due date: An ultrasound scan.Clinical examination of pelvis (assessed alongside correct information about your menstrual cycle). Doppler ultrasonography (which can be used after 10 to 12 weeks of pregnancy). Human Chorionic Gonadotropin (hCG) Pregnancy Test.
                            </span>
                        </div>
                    </div> */}
                </div>
                <script type="application/ld+json" dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": [{
                            "@type": "Question",
                            "name": "Q. How many weeks pregnant am I?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "A. To learn how far along you are in your pregnancy or how many weeks pregnant you are, you can use a pregnancy days calculator. Pregnancy usually ranges from 38 to 42 weeks. Calculating the gestational age can be tricky because your baby's age is two weeks less than the pregnancy start date"
                            }
                        }, {
                            "@type": "Question",
                            "name": "Q. Why is the due date calculated from the period?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "A. According to NHS, the pregnancy typically lasts from 37 to 42 weeks from the first day of your last period (6). This makes it easier to calculate the due date using the details of the last menstrual cycle."
                            }
                        },{
                            "@type": "Question",
                            "name": "Q. Is the due date based on ovulation?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "A. No, the due date is not based on ovulation. It is based on the date of conception."
                            }
                        }, {
                            "@type": "Question",
                            "name": "Q. How do you calculate pregnancy weeks from the due date?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "A. Pregnancies typically last about 38 to 40 weeks. To estimate your conception date, note the start of your last menstrual period (LMP) and count 40 weeks (280 days) from that date."
                            }
                        },{
                            "@type": "Question",
                            "name": "Q. Can your due date change?",
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": "A. Yes, the pregnancy due date can change based on your ultrasound scans and last menstrual cycle. It is common for mothers to be sure of their pregnancy and due date calculator is one such tool that simplifies the pregnancy journey. While it is a beneficial tool, it is essential to remember that it is just an estimate, not a guarantee. Be alert, keep yourself informed about different pregnancy nuances, stay in touch with your doctor, and enjoy the pregnancy journey while it lasts."
                            }
                        }]
                    })
                }}></script>
                </div>
            </div>
            
        </div>
    );
}
